import Vue from 'vue';
import { mapGetters } from 'vuex';
import HelpIcon from 'src/components/project/analysis/results/widgets/HelpIcon.vue';
import DownloadExportButton from 'src/components/project/analysis/results/widgets/DownloadExportButton.vue';
import TimelineTrendBase from 'src/components/project/analysis/results/widgets/TimelineTrendBase.vue';
export default Vue.extend({
    components: { HelpIcon, DownloadExportButton },
    extends: TimelineTrendBase,
    data() {
        return {
            field: this.$store.getters.defaultDateField
        };
    },
    computed: {
        ...mapGetters([
            'currentAnalysis', 'analysisTimeline', 'currentModel', 'defaultDateField',
        ]),
        help() {
            return `<p>Graphs the trajectory of this query over time.</p>
              <p><b>Note:</b> Your data must contain a time label for this to work effectively</p>`;
        }
    },
});
